
webpack.register(
    'components/video-landing/live-video-drawer/featured-group-header/featured-group-header',
    function() {
        return require('components/video-landing/live-video-drawer/featured-group-header/featured-group-header');
    },
    false
);
webpack.register(
    'components/video-landing/live-video-drawer/featured-holes-header/featured-holes-header',
    function() {
        return require('components/video-landing/live-video-drawer/featured-holes-header/featured-holes-header');
    },
    false
);
var stache = require('can/view/stache/stache');
module.exports = stache("<can-import from=\"components/video-landing/live-video-drawer/featured-group-header/featured-group-header\" />\r\n<can-import from=\"components/video-landing/live-video-drawer/featured-holes-header/featured-holes-header\" />\r\n\r\n<div class=\"c-live-video-drawer\">\r\n    <div class=\"c-live-video-drawer__inner\">\r\n        {{#if data}}\r\n            {{#eq type DRAWER_TYPES.GROUP}}\r\n                <featured-group-header {data}=\"data\" {channel-name}=\"channelName\"></featured-group-header>\r\n            {{/eq}}\r\n            {{#eq type DRAWER_TYPES.HOLES}}\r\n                <featured-holes-header {data}=\"data\"></featured-holes-header>\r\n            {{/eq}}\r\n        {{/if}}\r\n    </div>\r\n</div>");